export const SORT_TEXT = "Sort";
export const RECOMMENDED_TEXT = "Recommended";
export const PRICE_ASC = "Price (Low to High)";
export const PRICE_DESC = "Price (High to Low)";

export const CHOOSE_SORT_OPTION_TEXT = "Choose a Sort Option";
export const CHANGE_SORT_OPTION_TEXT = "Change Sort Option";

export const VACATION_RENTALS_SORT_BUTTON_LABEL = "Sort by";
